import { ModulePlaceholder } from "@/components/common/ModulePlaceholder";
import { useI18n } from "@/i18n/I18nProvider";

export default function UtilisateursPage() {
  const { t } = useI18n();
  return (
    <ModulePlaceholder
      testId="utilisateurs-page"
      title={t.modules.utilisateurs.title}
      subtitle={t.modules.utilisateurs.subtitle}
      body={t.modules.utilisateurs.body}
      capabilities={[
        "Liste des utilisateurs internes",
        "Attribution des rôles et permissions (phase ultérieure)",
        "Authentification à définir avec le backend existant",
      ]}
      backendEndpoints={[]}
      missingEndpoints={[
        "Endpoint backend supplémentaire requis : gestion des utilisateurs, rôles et authentification",
      ]}
    />
  );
}
